import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { enqueueListBulkRequestRpc } from '../../../../../__generated__/chirp/com/hubspot/custom/enrichment/rpc/client/SmartPropertiesBulkService';
import { performCRMSearchWithEmptyProperties } from '../../../CRMSearchProvider/client';
import { FILL_EMPTY_ONLY_OPTION_VAL } from '../../../../constants';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export async function fetchListName(context) {
  const {
    listId
  } = context;
  const list = await http.get(`inbounddb-lists/v1/lists/${listId}`);
  return {
    name: list.name,
    listVersion: list.listVersion
  };
}
export async function fetchListSize(context) {
  const {
    listId,
    listVersion
  } = context;
  const response = await http.get(`inbounddb-lists/v1/list-membership-search/list/${listId}/${listVersion}/current-state`);
  return response.crmListSize;
}
export function runSmartFillList(context) {
  const isFillEmptyOnly = context.fillOption === FILL_EMPTY_ONLY_OPTION_VAL;
  return rpcClient.call(enqueueListBulkRequestRpc, {
    request: {
      listId: context.listId,
      objectTypeId: context.objectTypeId,
      propertyNames: context.selectedProperties,
      estimatedObjectCount: context.size,
      fillEmptyValuesOnly: isFillEmptyOnly
    }
  });
}
export async function getEmptyPropertiesCountForList(context) {
  const {
    selectionCrmSearchQuery,
    selectedProperties
  } = context;
  if (!selectionCrmSearchQuery || !selectedProperties.length) {
    return 0;
  }
  const result = await performCRMSearchWithEmptyProperties({
    query: selectionCrmSearchQuery
  }, selectedProperties);
  return result.total;
}